import React from 'react';

// MJV Logo - Connected M Symbol (Network/Ecosystem)
export const Logo = ({ className = "", size = "default" }) => {
  const sizes = {
    small: { width: 32, height: 32 },
    default: { width: 40, height: 40 },
    large: { width: 56, height: 56 }
  };

  const { width, height } = sizes[size] || sizes.default;

  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 40 40" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-testid="mjv-logo"
    >
      {/* Rounded square container */}
      <rect 
        width="40" 
        height="40" 
        rx="10" 
        fill="#1F2933"
      />
      
      {/* Connection lines forming M shape */}
      <path 
        d="M10 28L10 16L20 24L30 16L30 28" 
        stroke="white" 
        strokeWidth="2.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* Top connection line */}
      <path 
        d="M10 16L20 10L30 16" 
        stroke="#6366F1" 
        strokeWidth="2.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* Node dots - representing connected products */}
      <circle cx="10" cy="16" r="3" fill="white"/>
      <circle cx="20" cy="10" r="3" fill="#6366F1"/>
      <circle cx="30" cy="16" r="3" fill="white"/>
      <circle cx="20" cy="24" r="3" fill="white"/>
      <circle cx="10" cy="28" r="2.5" fill="#6366F1"/>
      <circle cx="30" cy="28" r="2.5" fill="#6366F1"/>
    </svg>
  );
};

// Favicon version - optimized for small sizes
export const LogoFavicon = () => (
  <svg 
    width="32" 
    height="32" 
    viewBox="0 0 32 32" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="8" fill="#1F2933"/>
    
    {/* Connection lines */}
    <path 
      d="M8 23L8 13L16 19L24 13L24 23" 
      stroke="white" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
    <path 
      d="M8 13L16 8L24 13" 
      stroke="#6366F1" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      fill="none"
    />
    
    {/* Nodes */}
    <circle cx="8" cy="13" r="2.5" fill="white"/>
    <circle cx="16" cy="8" r="2.5" fill="#6366F1"/>
    <circle cx="24" cy="13" r="2.5" fill="white"/>
    <circle cx="16" cy="19" r="2.5" fill="white"/>
    <circle cx="8" cy="23" r="2" fill="#6366F1"/>
    <circle cx="24" cy="23" r="2" fill="#6366F1"/>
  </svg>
);

// Full logo with text
export const LogoWithText = ({ className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="logo-with-text">
    <Logo size="default" />
    <span className="text-xl font-semibold tracking-tight text-[#1F2933]">
      MJV Holdings
    </span>
  </div>
);

export default Logo;
